module.exports = __webpack_public_path__ + "assets/img/Logitech-PW-Australia-Landing-page-w960.47641876.jpg";